import { render } from "./NewAdminLayout.vue?vue&type=template&id=6251815d"
import script from "./NewAdminLayout.vue?vue&type=script&lang=js"
export * from "./NewAdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__